import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="py-0">

      <div className="text-sm text-gray-500 mb-10">
        Home <span className="mx-2">/</span>
        Our Policies <span className="mx-2">/</span>
        <span className="text-black">Privacy Policy</span>
      </div>

      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-left">
          Privacy Policy – Happenhood
        </h1>
        <div className="w-full h-[1px] bg-gray-300 mx-auto mt-2"></div>

        <p className="text-sm text-gray-500 mt-2">
          Effective Date: 29 April 2026
        </p>
      </div>

      <div className="space-y-8 text-sm leading-7 text-gray-800">

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            1. Introduction
          </h2>
          <p>
            Happenhood (“we”, “our”, “us”) is owned and operated by Aimbeyond Infotech Private Limited, based in New Delhi, India.
            This Privacy Policy explains how we collect, use, disclose, and protect your personal data when you use our website and mobile application (collectively, the “Platform”).
            By using Happenhood, you agree to the collection and use of your information in accordance with this Privacy Policy.
          </p>
        </section>

        {/* 2 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            2. Scope
          </h2>
          <ul className="list-disc pl-5">
            <li>Our website (happenhood.com)</li>
            <li>Our mobile applications</li>
            <li>Services related to event discovery, reservations, and ticketing</li>
          </ul>
        </section>

        {/* 3 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            3. Information We Collect
          </h2>

          <p className="font-semibold mt-2">3.1 Personal Information</p>
          <ul className="list-disc pl-5">
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>City/location</li>
          </ul>

          <p className="font-semibold mt-2">3.2 Account & Booking Information</p>
          <ul className="list-disc pl-5">
            <li>Login credentials</li>
            <li>Event bookings or reservations</li>
            <li>Preferences and saved events</li>
          </ul>

          <p className="font-semibold mt-2">3.3 Device & Technical Information</p>
          <ul className="list-disc pl-5">
            <li>IP address</li>
            <li>Device type and ID</li>
            <li>Operating system and browser</li>
            <li>App usage data</li>
            <li>Cookies and similar technologies</li>
          </ul>

          <p className="font-semibold mt-2">3.4 Usage Data</p>
          <ul className="list-disc pl-5">
            <li>Events viewed or searched</li>
            <li>Time spent on the platform</li>
            <li>Interaction behavior</li>
          </ul>
        </section>

        {/* 4 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            4. How We Use Your Data
          </h2>
          <ul className="list-disc pl-5">
            <li>Create and manage your account</li>
            <li>Enable event reservations and bookings</li>
            <li>Share booking details with event organizers</li>
            <li>Send confirmations, reminders, and updates</li>
            <li>Improve our platform and user experience</li>
            <li>Provide customer support</li>
            <li>Send promotional communications (with your consent)</li>
            <li>Ensure security and prevent misuse</li>
          </ul>
        </section>

        {/* 5 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            5. Payments (Current Model)
          </h2>
          <ul className="list-disc pl-5">
            <li>Currently, Happenhood does not process online payments.</li>
            <li>All payments (if applicable) are made directly at the event venue</li>
            <li>We do not collect or store payment card or banking information at this time</li>
          </ul>
        </section>

        {/* 6 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            6. Future Payment Integration
          </h2>
          <ul className="list-disc pl-5">
            <li>Payments will be processed through secure third-party payment gateways</li>
            <li>We will update this Privacy Policy accordingly</li>
            <li>We will not store sensitive financial data unless required and compliant with applicable laws</li>
          </ul>
        </section>

        {/* 7 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            7. Data Retention
          </h2>
          <ul className="list-disc pl-5">
            <li>Provide services</li>
            <li>Maintain records of bookings</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p className="mt-2">
            After this period, data is deleted or anonymized.
          </p>
        </section>

        {/* 8 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            8. Sharing of Information
          </h2>

          <p>We may share your data with:</p>

          <div className="mt-3 space-y-3">
            <div>
              <p className="font-semibold">8.1 Event Organizers</p>
              <ul className="list-disc pl-5">
                <li>To facilitate your reservation and event access</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">8.2 Service Providers</p>
              <ul className="list-disc pl-5">
                <li>Hosting and cloud services</li>
                <li>Customer support tools</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">8.3 Analytics Providers</p>
              <ul className="list-disc pl-5">
                <li>To understand usage and improve the platform</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">8.4 Legal Authorities</p>
              <ul className="list-disc pl-5">
                <li>When required by law or to protect our rights</li>
              </ul>
            </div>
          </div>

          <p className="mt-3">
            We ensure appropriate safeguards are in place for all data sharing.
          </p>
        </section>

        {/* 9 */}
        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            9. Third-Party Services
          </h2>
          <ul className="list-disc pl-5">
            <li>Our Platform may contain links to third-party services.</li>
            <li>We are not responsible for their privacy practices.</li>
            <li>We use cloud services (such as AWS SES, S3, Cognito) to securely store and process data.</li>
            <li>We may use Google login, Facebook login for authentication.</li>
            <li>These third-party services have their own privacy policies governing data usage.</li>
            <li>We do not sell your personal information to third parties.</li>
          </ul>
        </section>

        {/* EXISTING CONTENT WITH NUMBERING ONLY */}

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            10. Information We Collect
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Your mobile number for account creation, login, and communication.</li>
            <li>Your email address for notifications, updates, and account recovery.</li>
            <li>Your date of birth to verify age and provide age-appropriate experiences.</li>
            <li>Basic profile details you choose to provide.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            11. Why we use Camera and Microphone
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>To enable live streaming so you can share video and audio in real time.</li>
            <li>To allow participation when invited on stage.</li>
            <li>To support voice features like voice notes or audio chats.</li>
            <li>To test your devices before going live — this data is never stored.</li>
            <li>Viewers can watch streams without enabling camera or microphone.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            12. How we use your information
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>To create and manage your account.</li>
            <li>To communicate updates, alerts, and notifications.</li>
            <li>To improve platform functionality and user experience.</li>
            <li>To maintain safety, prevent fraud, and enforce policies.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            13. Data Retention
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>We retain your personal information only as long as necessary.</li>
            <li>Account data is stored until you delete your account.</li>
            <li>Temporary data (like live stream media) is not stored unless recorded.</li>
            <li>We may retain certain data to comply with legal obligations.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-amber-600 text-lg font-semibold mb-2">
            14. Contact Us
          </h2>
          <p>If you have questions, contact us at:</p>
          <p className="text-blue-500">support@happenhood.com</p>
          <p>📍 Happenhood, Noida, India</p>
        </section>

      </div>
    </div>
  );
}